<label class="field-label bd-field-label">{{ label }}</label>
@for (ctrl of formCtrl.controls; track ctrl; let i = $index; let last = $last; let first = $first) {
  <div class="form-group" [formGroup]="ctrl" [class.first]="first">
    <div class="form-control name">
      <input class="bd-text-input tall w-full" formControlName="name" placeholder="Key" />
    </div>
    <div class="form-control type">
      <mat-button-toggle-group class="button-group-input" name="type" formControlName="type">
        <mat-button-toggle [value]="ParameterType.Dynamic">Dynamic</mat-button-toggle>
        <mat-button-toggle [value]="ParameterType.FixedValue">Fixed Value</mat-button-toggle>
        <mat-button-toggle [value]="ParameterType.Pagination">Pagination</mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    @if (ctrl.value.type === ParameterType.Dynamic) {
      <div class="form-control optional">
        <mat-slide-toggle disableRipple class="bd-toggle px-8" formControlName="optional">
          Optional
        </mat-slide-toggle>
      </div>
    }
    @if (ctrl.value.type === ParameterType.FixedValue) {
      <div class="form-control value">
        <input class="bd-text-input tall w-full" formControlName="value" placeholder="Value" />
      </div>
    }
    @if (ctrl.value.type === ParameterType.Pagination) {
      <div class="form-control pagination">
        <blaze-select
          [allowNone]="false"
          [options]="paginationMethods"
          [showNoneOption]="false"
          [showSelection]="true"
          class="select-input tall"
          formControlName="paginationMethod"
        />
      </div>
    }
    <div class="form-control actions">
      @if (!last) {
        <button blazeIconButton type="button" (click)="deleteParam(i)">
          <mat-icon svgIcon="icon_close_16" />
        </button>
      }
    </div>
  </div>
}
